import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Userdashboardheader from '../userdashboardheader/Userdashboardheader';
import Loader from '../Loader';
import axios from 'axios';
import './investments.css';

const Investments = ({ route }) => {
  const navigate = useNavigate();
  const [stakes, setStakes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStakes = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await axios.get(`${route}/staking/stakes`, {
          headers: {
            'x-access-token': token
          }
        });

        setStakes(response.data);
      } catch (error) {
        console.error('Error fetching stakes:', error);
        setError('Failed to load staking history');
        if (error.response?.status === 401) {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchStakes();
  }, [route, navigate]);

  return (
    <div>
      <Userdashboardheader route={route} />
      {loading && <Loader />}
      
      <div className="page-swiper-wrapper">
        <div className="page-header">
          <h3>Your Staking History</h3>
          <h2>Staking Logs</h2>
          <p>Track all your staking positions and rewards</p>
        </div>

        {error ? (
          <div className="error-message">
            <p>{error}</p>
          </div>
        ) : stakes.length === 0 ? (
          <div className="failure-page no-referral-page">
            <img src="/preview.gif" alt="" className="failure-img" />
            <p>No staking history found. Start earning rewards by staking now!</p>
            <button onClick={() => navigate('/plans')} className="action-button">
              Start Staking
            </button>
          </div>
        ) : (
          <div className="transaction-container no-ref">
            <table>
              <thead>
                <tr>
                  <td>Asset</td>
                  <td>Plan</td>
                  <td>Amount</td>
                  <td>APY</td>
                  <td>Rewards</td>
                  <td>Start Date</td>
                  <td>End Date</td>
                  <td>Status</td>
                </tr>
              </thead>
              <tbody>
                {stakes.map(stake => (
                  <tr key={stake._id}>
                    <td>{stake.cryptoAsset}</td>
                    <td>{stake.plan}</td>
                    <td>${stake.amount.toFixed(2)} USD</td>
                    <td>{stake.apy}%</td>
                    <td>${stake.rewards.toFixed(2)} USD</td>
                    <td>{new Date(stake.startDate).toLocaleDateString()}</td>
                    <td>{new Date(stake.endDate).toLocaleDateString()}</td>
                    <td>
                      <span className={`status ${stake.status}`}>
                        {stake.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Investments;